export const SmoothScroll = ({ children }) => {
  return <>{children}</>;
};
